/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

// Shared helpers for pulling a display-safe message/field errors out of an
// axios error. `error.response` is undefined for network-level failures, so
// callers must never chain straight into `error.response.data.message`.

export const extractErrorMessage = (error, fallback) =>
  error?.response?.data?.message || error?.message || fallback;

export const extractFieldErrors = (error) => {
  const data = error?.response?.data?.data;
  return data && typeof data === "object" && !Array.isArray(data) ? data : {};
};

export const extractFirstFieldError = (error, field) => {
  const fieldErrors = extractFieldErrors(error)[field];
  return Array.isArray(fieldErrors) ? fieldErrors[0] : undefined;
};

// react-query hands onError the raw axios error, which react-hook-form cannot display. Surface
// the first field error the server sent, falling back to the general message.
export const setRootFormError = (setError, error) => {
  const firstFieldError = Object.values(extractFieldErrors(error)).find(
    (errors) => Array.isArray(errors) && errors.length
  );

  setError("root", {
    message: firstFieldError
      ? firstFieldError[0]
      : extractErrorMessage(error, "An unexpected error occurred"),
  });
};
